import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: {
        usageChartLatestMonth: '',
        usageChartDaily: ''
    },
    apiKey: '',
    hasApiKey: '',
    startDate: '',
    endDate: '',
    token: '',
    usage: {
        latestMonth: [],
        daily: []
    },
    userGuide: {}
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
